// SceneRunner — dispatches the active scene to its matching template inside
// AnimatePresence. The orb's layoutId="orb" persists through transitions.

import { AnimatePresence } from 'framer-motion';
import type { Scene } from '../types';
import { HeroTemplate } from '../templates/HeroTemplate';
import { SequenceTemplate } from '../templates/SequenceTemplate';
import { CollectionTemplate } from '../templates/CollectionTemplate';
import { DichotomyTemplate } from '../templates/DichotomyTemplate';
import { QuoteTemplate } from '../templates/QuoteTemplate';
import { StatPanelTemplate } from '../templates/StatPanelTemplate';
import { TechStackTemplate } from '../templates/TechStackTemplate';
import { ArchitectureTemplate } from '../templates/ArchitectureTemplate';
import { ProfileTemplate } from '../templates/ProfileTemplate';
import { ContactTemplate } from '../templates/ContactTemplate';
import { BookingTemplate } from '../templates/BookingTemplate';
import { WelcomeTemplate } from '../templates/WelcomeTemplate';

interface SceneRunnerProps {
  scene: Scene | null;
}

export function SceneRunner({ scene }: SceneRunnerProps) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      {scene && (
        <div key={scene.id}>
          {renderTemplate(scene)}
        </div>
      )}
    </AnimatePresence>
  );
}

function renderTemplate(scene: Scene) {
  switch (scene.topology) {
    case 'hero':         return <HeroTemplate         content={scene.content} />;
    case 'sequence':     return <SequenceTemplate     content={scene.content} />;
    case 'collection':   return <CollectionTemplate   content={scene.content} />;
    case 'dichotomy':    return <DichotomyTemplate    content={scene.content} />;
    case 'quote':        return <QuoteTemplate        content={scene.content} />;
    case 'stat-panel':   return <StatPanelTemplate    content={scene.content} />;
    case 'tech-stack':   return <TechStackTemplate    content={scene.content} />;
    case 'architecture': return <ArchitectureTemplate content={scene.content} />;
    case 'profile':      return <ProfileTemplate      content={scene.content} />;
    case 'contact':      return <ContactTemplate      content={scene.content} />;
    case 'booking':      return <BookingTemplate      content={scene.content} />;
    case 'welcome':      return <WelcomeTemplate      content={scene.content} />;
    default:             return <HeroTemplate         content={scene.content} />;
  }
}
